
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"19","cy":"19","r":"19","fill":"#06F"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.982 12.838a1.92 1.92 0 10-.001-3.837 1.92 1.92 0 00.002 3.837h-.001zm6.777 5.923a1.385 1.385 0 00-.12-.17 2.129 2.129 0 00-.099-.22 95.13 95.13 0 00-2.207-4.058c1.501-.479 2.873-.042 3.953 1.47.877 1.23 2.931.05 2.042-1.194-2.089-2.925-5.203-3.652-8.322-1.8a1.24 1.24 0 00-.318.264 2.346 2.346 0 00-.676.412.878.878 0 00-.444.297c-.917 1.169-1.79 2.505-1.132 4.005.032.075.07.145.112.212 0 0 .95 1.212 2.886 1.21.165.007.335.013.514.013.09 0 .176 0 .259-.003.631-.01.915-.514.91-.977-.003-.455-.277-.915-.88-.915h-.054c-.119.002-.224.004-.329.004-.263 0-.61-.008-.95-.073a1.968 1.968 0 01-.154-.041l-.043-.013c-.062-.017-.124-.035-.151-.04l-.032.002a.304.304 0 01-.149-.124v-.379l.022-.056.009-.021.441.167.034.01.035.01.079.021c.298.056.616.063.86.063.117 0 .235-.001.352-.003h.03c.88 0 1.348.696 1.354 1.384.006.71-.465 1.438-1.376 1.454-.085.002-.175.002-.267.002-.09 0-.176-.002-.262-.004l.103.197c.06.115.121.23.18.346a14.795 14.795 0 00-2.988 2.034c-.545.476-.455 1.098-.09 1.518.09.191.24.366.467.503l1.274.765.005.003.005.003 2.38 1.429c1.311.787 2.5-1.259 1.194-2.042l-1.694-1.017-.675-.405c.76-.512 1.58-.935 2.447-1.239.144-.05.266-.118.37-.2l2.028 3.445v.002l1.491 2.53c.773 1.314 2.818.125 2.042-1.193l-.948-1.61-3.518-5.978zm-16.036-2.396V11.44h5.628l-1.419 2.462 1.419 2.463h-5.629.001zm-2.004-5.54h1.362v8.754H8.719v-8.754zm-1 9.396h3.366v.917h.718v.642H7v-.642h.719v-.917z","fill":"#fff"}})])
          )
        }
      }
    